import apiClient from './axios-instance'
import {
  GetProfileResponse,
  UpdateProfileRequest,
  UpdateProfileResponse,
  UploadProfilePictureResponse,
  ChangePasswordRequest,
  ChangePasswordResponse,
  GetNotificationSettingsResponse,
  UpdateNotificationSettingsRequest,
  UpdateNotificationSettingsResponse,
} from '@/lib/types/settings.types'

/**
 * Settings API Service
 * Handles profile, password, and notification settings operations
 */
export const settingsApi = {
  /**
   * Get educator profile
   * GET /educator/profile
   */
  getProfile: async (): Promise<GetProfileResponse> => {
    const response = await apiClient.get<GetProfileResponse>('/educator/profile')
    return response.data
  },

  /**
   * Update educator profile
   * PATCH /educator/profile
   */
  updateProfile: async (data: UpdateProfileRequest): Promise<UpdateProfileResponse> => {
    const response = await apiClient.patch<UpdateProfileResponse>('/educator/profile', data)
    return response.data
  },

  /**
   * Upload profile picture
   * POST /educator/profile/picture
   * Max size: 5MB, Allowed: jpg, jpeg, png, webp
   */
  uploadProfilePicture: async (file: File): Promise<UploadProfilePictureResponse> => {
    const formData = new FormData()
    formData.append('picture', file)

    const response = await apiClient.post<UploadProfilePictureResponse>(
      '/educator/profile/picture',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    return response.data
  },

  /**
   * Change password
   * POST /educator/change-password
   */
  changePassword: async (data: ChangePasswordRequest): Promise<ChangePasswordResponse> => {
    const response = await apiClient.post<ChangePasswordResponse>(
      '/educator/change-password',
      data
    )
    return response.data
  },

  /**
   * Get notification settings
   * GET /educator/notifications
   */
  getNotificationSettings: async (): Promise<GetNotificationSettingsResponse> => {
    const response = await apiClient.get<GetNotificationSettingsResponse>(
      '/educator/notifications'
    )
    return response.data
  },

  /**
   * Update notification settings
   * PATCH /educator/notifications
   */
  updateNotificationSettings: async (
    data: UpdateNotificationSettingsRequest
  ): Promise<UpdateNotificationSettingsResponse> => {
    const response = await apiClient.patch<UpdateNotificationSettingsResponse>(
      '/educator/notifications',
      data
    )
    return response.data
  },
}

